<template>
    <div class="timeline-row" style="cursor: pointer" >
        <div class="timeline-icon" @click.prevent="iconClicked">
            <div class="bg-primary-300">
                <i class="fa fa-puzzle-piece"></i>
            </div>
        </div>
        <div id="newItemBlock" class="panel panel-flat bg-grey-100 timeline-content">
            <div class="panel-body text-center text-grey-400 text-size-large">
                <form v-on:submit.prevent="proccessAdd">
                    <div class="input-group">
                        <span class="input-group-addon" :class="{ 'bg-primary': isActive }"><i class="fa fa-link"></i></span>
                        <input type="text" class="form-control" :class="{ 'bg-primary-300': isActive, 'bg-grey-100': !isActive }"
                               placeholder="Enter new link" @focus="toggle" @blur="toggle" v-model="url" @input="urlChanged">
                        <span v-if="url != ''" class="input-group-addon" :class="{ 'bg-primary': isActive && isPublic, 'bg-danger': isActive && !isPublic }"
                              @click.prevent="changePublic">{{ modeTitle }}</span>
                        <span class="input-group-addon" :class="{ 'bg-primary': isActive }" @click="proccessAdd">Save</span>
                    </div>
                </form>
            </div>
            <note-item v-if="type" :item="{owner: owner, title: title, content: content, image: image, description: description, type: type}"></note-item>

        </div>

    </div>
</template>
<script>
    import { mapActions, mapGetters, mapState } from 'vuex'
    import axios from 'axios'
    import _ from 'lodash'
    import Item from './Item.vue'
    import swal from 'sweetalert2'

    export default {
        computed: {
          ...mapGetters(['getUser', 'loggedIn']),
          ...mapState(['mode'])
        },
        components: {
            noteItem: Item,
        },
        watch: {
            'mode': function (mode) {
                this.modeTitle = (mode === 'public' ? 'Public' : mode === 'extra' ? 'Extra' : 'Private');
                this.isPublic = (mode === 'public')
            }
        },
        data() {
            return {
                errors: [],
                tick: 0,
                isActive: false,
                isPublic: true,
                modeTitle: 'Public',
                owner: '1',
                url: '',
                type: '',
                urlType: '',
                title: '',
                content: '',
                image: '',
                description: ''
            };
        },
        methods: {
          ...mapActions(['changeMode']),
          iconClicked () {
                this.tick += 1;
                if (this.loggedIn && this.tick === 13) {
                    this.changeMode({mode:'extra'});
                    swal(
                      'Great!',
                      'Switched to extra mode',
                      'success')
                }
            },
            toggle() {
                if (this.url === '') {
                    this.isActive = !this.isActive;
                }
            },

            changePublic () {
                if (this.mode !== 'extra') {
                    this.isPublic = !this.isPublic;
                    this.modeTitle = (this.isPublic ? 'Public' : 'Private');
                }
            },

            block () {
                $('#newItemBlock').block({
                    message: '<i class="fa fa-spinner spinner"></i>',
                    overlayCSS: {
                        backgroundColor: '#1B2024',
                        opacity: 0.85,
                        cursor: 'wait'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'none',
                        color: '#fff'
                    }
                });
            },

            urlChanged: _.debounce(
                function () {
                    if (this.url.length === 0) {
                        this.resetData();
                        return;
                    }
                    this.urlType = this.getUrlType();
                    this.type = this.getType();
                    this.content = this.generateContent();
                    var isValid = new RegExp(/^((http|https):\/\/)?[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,20})(?:[^ "]+)$/).test(this.url);
                    if (isValid && this.type === 'url') {
                        this.block();
                        this.generatePreview();
                    } else if (this.type === 'instagram') {
                        window.instgrm.Embeds.process();
                    }
                }, 800),

            proccessAdd() {
                if (this.loggedIn) {
                    var item = {
                        type: this.type,
                        owner: this.getUser.uid,
                        private: !this.isPublic,
                        title: this.title,
                        content: this.content,
                        image: this.image,
                        description: this.description
                    };
                    this.$emit('itemAdded', item);
                    this.resetData();
                    swal(
                        'Awesome!',
                        'New link saved',
                        'success')
                } else {
                    swal(
                        'Please login!',
                        'In order to add new puzzle you need to be logged in.',
                        'info')
                }
            },

            getUrlType() {
                var url = this.url.toLowerCase();
                var types = ['instagram.com/p/', 'instagram', 'youtu', 'vimeo', 'spotify', 'soundcloud'];
                for (var i = 0; i < types.length; i++) {
                    if (url.indexOf(types[i]) > -1) {
                        if (types[i] === 'youtu') return 'youtube';
                        else if (types[i] === 'instagram.com/p/') return 'instagram-post';
                        else if (types[i] === 'instagram') return 'instagram-profile';
                        return types[i];
                    }
                }
                if (url.endsWith('.jpg') || url.endsWith('.png') || url.endsWith('.jpeg')) {
                    return 'image'
                }
                return 'url';
            },

            getType() {
                const urlType = this.urlType;
                if (urlType === 'youtube' || urlType === 'vimeo') return 'video';
                else return urlType;
            },

            generateContent() {
                var type = this.urlType,
                    url = this.url;
                if (type === 'youtube') {
                    return url.replace('http:', 'https:').replace('youtu.be', 'youtube.com').replace('watch?v=', 'embed/');
                } else if (type === 'vimeo') {
                    return url.replace('http:', 'https:').replace('www.', '').replace('vimeo.com/', 'player.vimeo.com/video/')
                        + '?title=0&amp;byline=0&amp;portrait=0';
                } else if (type === 'spotify') {
                    if (url.indexOf('spotify:track:') > -1) {
                        return url.replace('spotify:track:', 'https://open.spotify.com/embed/track/');
                    }
                    return url.replace('http:', 'https:').replace('www.', '').replace('/track/', '/embed/track/');
                } else if (type === 'soundcloud') {
                        return url.replace('soundcloud:', '');
                }
                return url.replace('http:', 'https:');

            },

            generatePreview () {
                axios.get('https://api.linkpreview.net/?key=5998a51047759141facdacb30c9b2e86172c3cfdbecc1&q=' + this.url)
                    .then(response => {
                        this.title = response.data.title;
                        this.description = response.data.description;
                        this.image = (response.data.image) ? response.data.image.replace('http:', 'https:') : '';
                        $('#newItemBlock').unblock();
                    })
                    .catch(e => {
                        this.errors.push(e);
                        $('#newItemBlock').unblock();
                    })
            },

            resetData () {
                this.url = '';
                this.type = '';
                this.owner = '';
                this.title = '';
                this.content = '';
                this.image = '';
                this.description = '';
            }
        }
    }

</script>

<style scoped>
    .timeline-icon .fa {
        font-size: 24px;
        padding-left:11px
    }
</style>



// WEBPACK FOOTER //
// NewItem.vue?1af567d6